import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("no_session"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (attempts > 15) { setStatus("timeout"); return; }
        setAttempts(a => a + 1);
        setTimeout(poll, 2000);
      } catch { if (!cancelled) setStatus("error"); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, attempts]);

  return (
    <div className="grain min-h-screen bg-[#050505] text-white">
      <Nav />
      <div className="mx-auto flex min-h-[calc(100vh-73px)] max-w-2xl flex-col items-start justify-center px-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#E5FF00]">/ TRANSACTION · SECURE CHANNEL</div>
        {status === "checking" && (
          <>
            <h1 className="mt-3 font-display text-5xl font-medium tracking-tighter">Confirming…</h1>
            <p className="mt-4 font-mono text-sm text-zinc-500">Verifying with Stripe · attempt {attempts + 1}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mt-4 h-12 w-12 text-[#00FF66]" strokeWidth={1.5} />
            <h1 data-testid="pay-success-title" className="mt-4 font-display text-5xl font-medium tracking-tighter">Payment Confirmed.</h1>
            <p className="mt-4 text-zinc-400">The AI wizard is now operating in Pro mode on your behalf.</p>
            <Button data-testid="pay-success-cta" onClick={() => nav("/dashboard")}
              className="btn-cta mt-10 h-12 rounded-none border border-[#E5FF00] bg-[#E5FF00] px-8 font-mono text-[11px] uppercase tracking-[0.25em] text-black hover:bg-transparent hover:text-[#E5FF00]">
              Open Console →
            </Button>
          </>
        )}
        {(status === "timeout" || status === "error" || status === "no_session") && (
          <>
            <h1 className="mt-3 font-display text-4xl font-medium tracking-tighter text-[#FF3333]">Payment status unclear.</h1>
            <p className="mt-4 text-zinc-400">If you completed checkout, refresh in a moment or check your email.</p>
            <Button onClick={() => nav("/dashboard")} className="btn-cta mt-8 h-11 rounded-none border border-white/20 bg-transparent px-6 font-mono text-[11px] uppercase tracking-[0.25em]">
              Go to Console
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
